import {showModalType} from 'stores/actions/typedModalAction';
import {kickUser as kickOtherUsers} from '../softwareUpdaterBusiness';
import {hideLoading, setDrawerVisibility, showLoading, showSnackbar} from '../../actions/appStateAction';
import {
  FastRobotErrorcode,
  Feedback,
  ModalType,
  RestoreResult,
  SignalREvent,
  ViewMode,
} from '../../../constants/dataEnum';
import {resolveIntl, setErrorCodeNumber} from '../commonBusiness';
import {logout} from '../sessionBusiness';
import {handleRestoreResult, resetBackupRestoreState} from '../backupAndRestoreBusiness';
import {rebuildHubConnections, setSoftwareReloadAttemptFromLocalStorage} from '../appBusiness';

const {formatMessage} = resolveIntl();

const isExecutorUser = (executorUserId, sessionState) => {
  const {user} = sessionState;
  const {userId} = user;

  return executorUserId === userId;
};

const isLoggedIn = (appState, sessionState) => {
  const {viewMode} = appState;
  const {sessionId} = sessionState;

  return (viewMode !== ViewMode.LOGIN || viewMode !== ViewMode.LOGIN_CONFIRMATION) && sessionId;
};

const eventLogger = (event, args) => {
  console.info('event received:', event);
  console.log(event, args);
};

export const subscribeEvent = (hubObject) => (dispatch, getState) => {
  hubObject.on(SignalREvent.PREPARE_BACKUP_START, (args) => {
    eventLogger(SignalREvent.PREPARE_BACKUP_START, args);

    const {status} = args;
    const {userId} = status;
    const {appState, sessionState} = getState();

    if (isExecutorUser(userId, sessionState) || !isLoggedIn(appState, sessionState)) return;

    dispatch(showLoading(formatMessage({id: 'loading.downloadBackupData.inProgress'})));
  });

  hubObject.on(SignalREvent.PREPARE_BACKUP_END, async (args) => {
    eventLogger(SignalREvent.PREPARE_BACKUP_END, args);

    const {status} = args;
    const {userId, errorCode} = status;
    const {appState, sessionState} = getState();

    if (!isLoggedIn(appState, sessionState)) return;
    if (isExecutorUser(userId, sessionState) && errorCode !== FastRobotErrorcode.NoError) {
      const errorNumber = await dispatch(setErrorCodeNumber(errorCode, true));

      dispatch(showModalType(ModalType.DOWNLOAD_BACKUP_DATA_FAILED, {errorNumber}));
    }

    dispatch(hideLoading());
  });

  hubObject.on(SignalREvent.PREPARE_RESTORE_START, (args) => {
    eventLogger(SignalREvent.PREPARE_RESTORE_START, args);

    const {status} = args;
    const {userId} = status;
    const {appState, sessionState} = getState();

    if (!isLoggedIn(appState, sessionState)) return;

    dispatch(kickOtherUsers(userId, false));

    if (!isExecutorUser(userId, sessionState)) {
      dispatch(showSnackbar(Feedback.INFO, formatMessage({id: 'snackbar.restoreData.sessionTaken'})));
    }
  });

  hubObject.on(SignalREvent.PREPARE_RESTORE_END, (args) => {
    eventLogger(SignalREvent.PREPARE_RESTORE_END, args);
    const {status} = args;
    const {userId, errorCode} = status;
    const {sessionState} = getState();

    if (isExecutorUser(userId, sessionState) && errorCode !== FastRobotErrorcode.NoError) {
      dispatch(showSnackbar(Feedback.ERROR, formatMessage({id: 'snackbar.restoreData.failed'})));
      dispatch(hideLoading());
      dispatch(resetBackupRestoreState());
    }
  });

  hubObject.on(SignalREvent.FINALIZE_RESTORE_START, (args) => {
    eventLogger(SignalREvent.FINALIZE_RESTORE_START, args);

    const {status, lastRestoreDate} = args;
    const {userId} = status;
    const {appState, sessionState} = getState();

    if (lastRestoreDate) localStorage.setItem('lastRestoreDate', lastRestoreDate);
    if (isLoggedIn(appState, sessionState) && isExecutorUser(userId, sessionState)) {
      dispatch(setDrawerVisibility(false));
      dispatch(logout());
      dispatch(hideLoading());
      dispatch(showSnackbar(Feedback.INFO, formatMessage({id: 'snackbar.restoreData.sessionTaken'})));
      dispatch(rebuildHubConnections());
    }
  });

  hubObject.on(SignalREvent.LAST_FINALIZE_RESTORE_RES_ON_CONNECTED, (args) => {
    eventLogger(SignalREvent.LAST_FINALIZE_RESTORE_RES_ON_CONNECTED, args);

    const {lastRestoreDate, lastRestoreResult} = args;
    const localLastRestoreDate = localStorage.getItem('lastRestoreDate', lastRestoreDate);

    if (lastRestoreDate === localLastRestoreDate && lastRestoreResult !== RestoreResult.NONE) {
      dispatch(handleRestoreResult(lastRestoreResult));
      localStorage.removeItem('lastRestoreDate');
      setSoftwareReloadAttemptFromLocalStorage(0);
    }
  });
};

export const unsubscribeEvent = (hubObject) => () => {
  hubObject.off(SignalREvent.PREPARE_BACKUP_START);
  hubObject.off(SignalREvent.PREPARE_BACKUP_END);
  hubObject.off(SignalREvent.PREPARE_RESTORE_START);
  hubObject.off(SignalREvent.PREPARE_RESTORE_END);
  hubObject.off(SignalREvent.FINALIZE_RESTORE_START);
  hubObject.off(SignalREvent.LAST_FINALIZE_RESTORE_RES_ON_CONNECTED);
};

export default subscribeEvent;
